module.exports = __webpack_public_path__ + "img/xmsb8.717672a3.png";